export enum UserRoleCRM {
  expert = 'Expert',
  manager = 'Manager',
  marketing = 'Marketing',
  admin = 'Admin',
  billing = 'Billing'
}

export enum UserPermissionsCRM {
  DASHBOARD = 'dashboard',
  LEADS = 'leads',
  SALES_PIPELINE = 'sales_pipeline',
  CLIENTS = 'clients',
  TASKS = 'tasks',
  CALLS = 'calls',
  DOCUMENTS = 'documents',
  WORKING_AGREEMENTS = 'working_agreements',
  REPORTS = 'reports',
  ADMIN = 'admin',
  ACCOUNT_SETTINGS = 'account_settings',
  BILLING = 'billing',
  CAMPAIGNS = 'campaigns',
  OPPORTUNITIES = 'opportunities',
  WEBSITE_LEADS = 'website_leads'
}
